module.exports = __webpack_public_path__ + "static/img/industry_icon1.5947b14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/industry_icon1.png
// module id = R+9x
// module chunks = 0